import { Col, Row } from "antd";
import { profileStore } from "src/stores/profile-store";
import { useShallow } from "zustand/react/shallow";
import { useMemo } from "react";
import { RolesNameEnum } from "src/entity/common/roles.enum";
import "../App.css";
import CategoryGroup from "src/components/CategoryGroup";

const defaultIconStyle = { fontSize: 64, fontWeight: 300 };

const HomePage = () => {
  const profile = profileStore(useShallow((state) => state.profile));

  const homeMenus = useMemo(() => {
    const items = [
      {
        key: "home-menu-1",
        icon: (
          <span className="material-symbols-outlined" style={defaultIconStyle}>
            assignment_ind
          </span>
        ),
        label: "My Task",
        new_background: "#2c2fb3",
        customClass: "blue-background",
        link: "/my-task",
      },
      {
        key: "home-menu-2",
        icon: (
          <span className="material-symbols-outlined" style={defaultIconStyle}>
            inventory
          </span>
        ),
        label: "VOCs Inventory",
        new_background: "#2c2fb3",
        customClass: "blue-background",
        link: "/vocs-inventory",
      },
      {
        key: "home-menu-3",
        icon: (
          <span className="material-symbols-outlined" style={defaultIconStyle}>
            factory
          </span>
        ),
        label: "Production",
        new_background: "#2c2fb3",
        customClass: "blue-background",
        link: "/production",
      },
      {
        key: "home-menu-4",
        icon: (
          <span className="material-symbols-outlined" style={defaultIconStyle}>
            flag
          </span>
        ),
        label: "Target",
        new_background: "#2c2fb3",
        customClass: "blue-background",
        link: "/target",
      },
      {
        key: "home-menu-5",
        icon: (
          <span className="material-symbols-outlined" style={defaultIconStyle}>
            summarize
          </span>
        ),
        label: "Report",
        new_background: "#59af9d",
        customClass: "green-background",
        link: "/report",
      },
      // {
      //   key: "home-menu-6",
      //   icon: (
      //     <span className="material-symbols-outlined" style={defaultIconStyle}>
      //       bar_chart_4_bars
      //     </span>
      //   ),
      //   label: "Dashboard",
      //   new_background: "#59af9d",
      //   customClass: "green-background",
      //   link: "/dashboard",
      // },
      {
        key: "home-menu-7",
        icon: (
          <span className="material-symbols-outlined" style={defaultIconStyle}>
            browse_activity
          </span>
        ),
        label: "Status",
        new_background: "#edbd5c",
        customClass: "orange-background",
        link: "/status",
      },
      {
        key: "home-menu-8",
        icon: (
          <span className="material-symbols-outlined" style={defaultIconStyle}>
            settings
          </span>
        ),
        label: "Setting",
        new_background: "#edbd5c",
        customClass: "orange-background",
        link: "/setting",
      },
    ];

    // console.log("step before return : ", profile?.roles);
    if (profile?.roles && (profile.roles.includes(RolesNameEnum.SYSTEM_ADMIN) || profile.roles.includes(RolesNameEnum.COMPANY_ADMIN))) {
    } else items.pop();
    // console.log("Items before return : ", items);
    return items;
  }, [profile?.roles]);

  // console.log("homeMenus :: ", homeMenus);

  return (
    <div style={{ padding: "50px" }}>
      <Row gutter={[40, 60]} justify={"center"}>
        {homeMenus.map((item) => (
          <Col key={item.key} xs={24} sm={12} md={8} lg={6}>
            <CategoryGroup
              link={item.link}
              customClass={item.customClass}
              new_background={item.new_background}
              label={item.label}
              icon={item.icon}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default HomePage;
